import React from "react";
import Box from "@mui/material/Box";
import { phoneDeviceFrameSx, phoneDeviceScreenSx } from "../styles/screenshotStyles";

/** Sleek smartphone chrome wrapping board / gallery content. */
export default function ScreenshotPhoneFrame({ children, sx = {} }) {
    return (
        <Box sx={{ ...phoneDeviceFrameSx, ...sx }}>
            <Box sx={phoneDeviceScreenSx}>{children}</Box>
        </Box>
    );
}
